import { useMutation } from '@tanstack/react-query';

import { callPost } from '@/api/fetcher';
import { MessageSent, Response } from '@/shared/types/tryIt';

type Variables = { brainId: string; message: MessageSent; host?: string };

type Result = { data: Response[]; headers: Record<string, string> };

const sendMessageRequest = ({ brainId, message, host = '/www' }: Variables): Promise<Result> =>
  callPost(`${host}/api/v1/brains/${brainId}/message`, message, undefined, {
    includeHeaders: true,
  });

export const useSendMessage = () => {
  const mutation = useMutation<Result, Error, Variables>({ mutationFn: sendMessageRequest });
  return { sendMessage: mutation.mutateAsync, isPending: mutation.isPending };
};
